import { useContext, createContext } from "react";
export var useDetailContext = function () {
    var context = useContext(DetailContext);
    if (context === undefined) {
        throw new Error("A component has been used outside of the Provider components");
    }
    return context;
};
export var DetailContext = createContext(undefined);
